import "core-js/stable";
import "regenerator-runtime/runtime";

import { createRoot } from "react-dom/client";
import "./i18n";
import App from "./App.tsx";
import "./index.css";

window.addEventListener("error", (e) => {
  document.body.innerHTML = `<pre style="white-space:pre-wrap;padding:16px;">JS Error: ${String(
    e.message
  )}</pre>`;
});

window.addEventListener("unhandledrejection", (e) => {
  document.body.innerHTML = `<pre style="white-space:pre-wrap;padding:16px;">Promise Error: ${String(
    e.reason
  )}</pre>`;
});

createRoot(document.getElementById("root")!).render(<App />);
